import styled from "@emotion/styled";

export type MascotSize = "sm" | "md" | "lg";
export type MascotDropShadow = "none" | "glow";

const SIZE_WIDTHS: Record<MascotSize, number> = {
  sm: 120,
  md: 180,
  lg: 240,
};

const DROP_SHADOWS: Record<MascotDropShadow, string> = {
  none: "none",
  glow: "drop-shadow(0 0 3px rgba(255, 255, 255, 0.85))",
};

export const MascotImage = styled.img<{
  $size: MascotSize;
  $dropShadow: MascotDropShadow;
  $interactive: boolean;
}>`
  width: ${({ $size }) => SIZE_WIDTHS[$size]}px;
  height: auto;
  display: block;
  user-select: none;
  pointer-events: ${({ $interactive }) => ($interactive ? "auto" : "none")};
  filter: ${({ $dropShadow }) => DROP_SHADOWS[$dropShadow]};
`;
